// extracted by mini-css-extract-plugin
export default {"root":"tableView_root__xO4w-","table":"tableView_table__+06ue"};